import { render, staticRenderFns } from "./BillNoData.vue?vue&type=template&id=0c7291a2"
import script from "./BillNoData.vue?vue&type=script&lang=js"
export * from "./BillNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports